const COREDNA_DOMAIN_ENDINGS = { com: 'com', couk: 'co.uk', coth: 'co.th' };
export const extractDomainParts = (hostname) => {
    let hostnameParts = hostname.split('.');
    const hasDoubleEnding = hostnameParts[hostnameParts.length - 2].length < 4;
    let ending = hostnameParts.pop();
    if (typeof ending === 'undefined') {
        throw new Error('Invalid hostname');
    }
    if (hasDoubleEnding) {
        ending = hostnameParts.pop() + '.' + ending;
    }
    let domain = hostnameParts.pop() + '.' + ending;
    if (['coredna.site', 'coredna.dev'].includes(domain)) {
        if (domain === 'coredna.dev') {
            hostnameParts.pop();
        }
        domain = hostnameParts.pop();
        if (domain.includes('-')) {
            domain = domain.substring(0, domain.indexOf('-'));
        }
        ending = '';
        for (const [text, realEnding] of Object.entries(COREDNA_DOMAIN_ENDINGS)) {
            if (domain.endsWith(text)) {
                ending = realEnding;
                domain = domain.slice(0, -text.length) + '.' + realEnding;
            }
        }
        if (!ending) {
            ending = domain.slice(-2);
            domain = domain.slice(0, -2) + '.' + ending;
        }
        hostnameParts = [];
    }
    let subdomain = hostnameParts.join('.');
    if (typeof domain === 'undefined') {
        throw new Error('Invalid hostname');
    }
    return {
        subdomain,
        subdomains: hostnameParts,
        domain,
        ending,
        full: hostname,
    };
};
export const shiftSubdomain = (domainData) => {
    if (domainData.subdomains.length < 2) {
        return domainData.domain;
    }
    domainData.subdomains.shift();
    return domainData.subdomains.join('.') + '.' + domainData.domain;
};
